import { createSelector } from "reselect";
import get from "src/lib/get";
import { getData } from ".";

export const canDelayBillingDate = createSelector(getData, (data) => {
  return get(data, "can_delay_billing_date", false);
});
